'use client';

import { ThemeProvider } from 'next-themes';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from './AuthContext';
import { OrganisationProvider } from './OrganisationContext';
import { EmployeeProvider } from './EmployeeContext';
import { SearchProvider } from './SearchContext';
import { ApplicantProvider } from './ApplicantContext';
import { JobsProvider } from './JobsContext';
import { TooltipProvider } from '@/components/ui/tooltip';
import { MasterProvider } from './MasterContext';
import { CandidateProvider } from './CandidateContext';
import { ExportProvider } from './ExportContext';
import { PostHogProvider } from '@/components/analytics/PostHogProvider';
import { AdminProvider } from './AdminContext';
import { IntegrationProvider } from './IntegrationContext';
import { HumanInterviewBookingProvider } from './HumanInterviewBookingContext';
import { BackendMaintenanceGate } from '@/components/BackendMaintenanceGate';

export function AppProvider({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <BackendMaintenanceGate>
        <TooltipProvider>
          <AuthProvider>
            <EmployeeProvider>
              <OrganisationProvider>
                <MasterProvider>
                  <CandidateProvider>
                    <ExportProvider>
                      <SearchProvider>
                        <PostHogProvider>
                          <AdminProvider>
                            <IntegrationProvider>
                              <ApplicantProvider>
                                <JobsProvider>
                                  <HumanInterviewBookingProvider>
                                    {children}
                                    <Toaster />
                                  </HumanInterviewBookingProvider>
                                </JobsProvider>
                              </ApplicantProvider>
                            </IntegrationProvider>
                          </AdminProvider>
                        </PostHogProvider>
                      </SearchProvider>
                    </ExportProvider>
                  </CandidateProvider>
                </MasterProvider>
              </OrganisationProvider>
            </EmployeeProvider>
          </AuthProvider>
        </TooltipProvider>
      </BackendMaintenanceGate>
    </ThemeProvider>
  );
}
